import { atom } from "recoil";
import { User, Columns, Filters } from "../components/types/user";

export const isOnlySearchState = atom({
  key: "isOnlySearchState",
  default: false,
});

export const isActiveFetchState = atom({
  key: "isActiveFetchState",
  default: false,
});
